import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

export interface Option {
  value: any;
  label?: string;
  labelKey?: string;
  selected?: boolean;
}

@Component({
    selector: 'app-data-filter-select',
    templateUrl: './data-filter-select.component.html',
    styleUrls: ['./data-filter-select.component.css'],
    standalone: false
})
export class DataFilterSelectComponent implements OnInit, OnChanges {

  @Input()
  label: string;

  @Input()
  model: any;

  @Input()
  disabled = false;

  @Input()
  options: Option[] = [];

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.disabled) {
      this.model = null;
      this.change();
    }
  }

  change() {
    this.modelChange.emit(this.model);
  }

}
